import * as React from 'react'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { Text } from 'web-makeup/dist/design-system/styles/typography'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'

import DefaultButton from '../DefaultButton/DefaultButton'
import { Brand as BrandType } from '../../../../typings/types'

import { Logo, Wrapper } from './BrandCard.style'

interface BrandCardProps {
  brand: BrandType
}

export const BrandCard: React.FC<BrandCardProps> = ({ brand }) => {
  const brandData = brand || {}
  const { avatar, uuid, tradingName, parent } = brandData
  const brandCity = brandData.city && brandData.city.name
  const brandCountry = brandData.city && brandData.city.country && brandData.city.country.name

  return (
    <>
      <Wrapper>
        <Logo
          icon={(avatar && avatar.cloudinaryId && decodeURIComponent(avatar.cloudinaryId)) || ''}
        />
        <Tooltip placement="bottom" overlay={<span>{tradingName}</span>}>
          <Text
            as="h3"
            fontSize="h2"
            color="black1"
            fontWeight="black"
            textAlign="center"
            style={{
              whiteSpace: 'nowrap',
              maxWidth: '80%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              margin: '0 auto',
              display: 'inline-block',
            }}
          >
            {tradingName}
          </Text>
        </Tooltip>
        <Text as="p" fontSize="h4" color="black1" textAlign="center">
          {brandCity}, {brandCountry}
        </Text>
        <DefaultButton
          fontSize="1rem"
          padding="0 1.5rem"
          buttonHeight="2.5rem"
          backgroundColor={colors.white}
          borderColor={colors.black1}
          color={colors.black1}
          rounded
          noWrap
          type="submit"
          onClick={() => {
            if (window.env) {
              window.location.href = `${window.env.BRAND_BASE_URL}/brand-dashboard/${uuid}`
            }
            localStorage.setItem('isSubBrand', 'true')
            parent && localStorage.setItem('parentId', parent.uuid || '')
          }}
        >
          Manage sub-brand
        </DefaultButton>
      </Wrapper>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandCard/BrandCard.tsx